// src/components/common/LoadingButton.js
// A native <button> that shows a lucide Loader2 spinner while `loading={true}`.
// Forces `disabled` and ignores `onClick` during the loading window. Otherwise pass-through.
// Use this for any button triggering an async operation (OAuth, save, send, payment).
// See CLAUDE.md → "Loading state — async buttons" for the rule and rationale.
//
// Component is unstyled by default — consumer provides className for color/size/padding.
// Renders a native <button> only (not polymorphic). Text-style clickables that need
// <span role="button"> per the tooltip-prevention rule should not use this component.
import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingButton = ({
  loading = false,
  loadingText,
  disabled = false,
  onClick,
  children,
  className,
  style,
  type = 'button',
  ariaLabel,
  ...rest
}) => {
  const isDisabled = loading || disabled;
  return (
    <button
      type={type}
      onClick={loading ? undefined : onClick}
      disabled={isDisabled}
      aria-label={ariaLabel}
      aria-busy={loading || undefined}
      className={className}
      style={style}
      {...rest}
    >
      {loading ? (
        <span className="inline-flex items-center gap-2">
          <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" />
          {loadingText !== undefined ? loadingText : children}
        </span>
      ) : (
        children
      )}
    </button>
  );
};

export default LoadingButton;
